import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(process.env.REACT_APP_TIMEZONE || dayjs.tz.guess());

export const Dayjs = dayjs;